import { render, staticRenderFns } from "./NamePlate.vue?vue&type=template&id=206ef518&scoped=true&"
import script from "./NamePlate.vue?vue&type=script&lang=ts&"
export * from "./NamePlate.vue?vue&type=script&lang=ts&"
import style0 from "./NamePlate.vue?vue&type=style&index=0&id=206ef518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ef518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {GFaIcon,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VToolbar})
